document.addEventListener('DOMContentLoaded', function () {
	const resetBtn = document.getElementById('resetFilters');
	if (!resetBtn) return;

	resetBtn.addEventListener('click', function () {
		const form = document.querySelector('.filtersForm');
		if (!form) return;

		// Reset all input/select fields
		form.querySelectorAll('input, select').forEach(field => {
			if (field.tagName === 'SELECT') {
				field.value = '*'; // default value
			} else {
				field.value = ''; // clear dates
			}
		});

		// Submit form without query params
		const action = form.getAttribute('action').split('?')[0];
		form.setAttribute('action', action);
		form.submit();
	});
});